import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useField } from "@madmedical/form";
import BaseDateTimeInput from "../molecules/Form/DateTimeInput";
const DateTimeInput = ({ name, isRequired, label }) => {
    const { control, isError, error } = useField(name);
    return (_jsx(Controller, { name: name, control: control, rules: { required: isRequired }, render: ({ field: { onChange, value } }) => (_jsx(BaseDateTimeInput, { onChange: onChange, value: value, label: label, isInvalid: isError, error: error })) }));
};
export default DateTimeInput;
